const intialSpireFtpState = {
    tab: 0,
    listRoute: '',
    currentSample: null,
    previewModal: false,
    patientsOptions: [],
    patientsOptionsLoading: false,
    datatableKeyLinked: 1,
    datatableKeyMissing: 1,
    loading: false,
};
const SpireFtp = {
    namespaced: true,
    state: intialSpireFtpState,
    getters: {},
    mutations: {
        SET_SPIRE_TAB(state, tab) {
            state.tab = tab;
        },
        SET_SPIRE_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_SPIRE_PREVIEW_MODAL(state, modal) {
            state.previewModal = modal;
        },
        SET_SPIRE_LIST_ROUTE(state, listRoute) {
            state.listRoute = listRoute;
        },
        INCREMENT_SPIRE_DATA_TABLE_KEY_LINKED(state, value = null) {
            if (value) {
                _.set(state, 'datatableKeyLinked', value);
            }
            if (!value) {
                state.datatableKeyLinked++;
            }
        },
        INCREMENT_SPIRE_DATA_TABLE_KEY_MISSING(state, value = null) {
            if (value) {
                _.set(state, 'datatableKeyMissing', value);
            }
            if (!value) {
                state.datatableKeyMissing++;
            }
        },
        SET_SPIRE_CURRENT_SAMPLE(state, sample) {
            _.set(state, 'currentSample', sample);
        },
        SET_SPIRE_CURRENT_SAMPLE_PATIENT(state, patientId) {
            _.set(state, 'currentSample.patient.id', patientId);
        },
        SET_SPIRE_PATIENTS_OPTIONS(state, patients) {
            _.set(state, 'patientsOptions', patients);
        },
        SET_SPIRE_PATIENTS_OPTIONS_LOADING(state, loading) {
            _.set(state, 'patientsOptionsLoading', loading);
        },
    },
    actions: {
        setSpireTab({ commit }, tab) {
            commit('SET_SPIRE_TAB', tab);
        },
        setSpireListRoute({ commit }, listRoute) {
            commit('SET_SPIRE_LIST_ROUTE', listRoute);
        },
        incremetDateTableKeyLinked({ commit }, value) {
            commit('INCREMENT_SPIRE_DATA_TABLE_KEY_LINKED', value);
        },
        incremetDateTableKeyMissing({ commit }, value) {
            commit('INCREMENT_SPIRE_DATA_TABLE_KEY_MISSING', value);
        },
        setPreviewModal({ commit }, modal) {
            commit('SET_SPIRE_PREVIEW_MODAL', modal);
        },
        setCurrentSamplePatient({ commit }, patientId) {
            commit('SET_SPIRE_CURRENT_SAMPLE_PATIENT', patientId);
        },
        setSpireLoading({ commit }, loading) {
            commit('SET_SPIRE_LOADING', loading);
        },
        async fetchCurrentSample({ commit }, sample) {
            const params = _.clone({
                id: sample.id,
                fields: 'id,original_data,file_name,patient.id',
            });
            return await axios.get(route('api.v1.spire-blood-results.index'), { params }).then((response) => {
                const data = _.clone(_.first(response.data.data) || null);
                commit('SET_SPIRE_CURRENT_SAMPLE', data);
            });
        },
        resetCurrentSample({ commit }) {
            commit('SET_SPIRE_CURRENT_SAMPLE', null);
        },
        async searchPatient({ commit }, options) {
            commit('SET_SPIRE_PATIENTS_OPTIONS_LOADING', true);
            return await axios
                .get(
                    route('api.v1.patients.options', {
                        sort: 'name',
                        name: options.name ? options.name : null,
                        pharmacy_site: options.pharmacy_site_id ? options.pharmacy_site_id : null,
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_SPIRE_PATIENTS_OPTIONS', data);
                })
                .finally(() => {
                    commit('SET_SPIRE_PATIENTS_OPTIONS_LOADING', false);
                });
        },
    },
};
export default SpireFtp;
